<template>
  <div class="flex-1 p-2">
    <p class="my-4 py-2 border-b text-lg">
      <i class="fa fa-exchange-alt text-brand"></i> Pending Request
    </p>

    <div v-if="search_pending" class="w-full text-center py-8">
      <i class="fa fa-spin fa-circle-notch"></i> searching
    </div>

    <div class="flex-1 flex justify-center flex flex-col" v-else-if="pending_request.length == 0">
      <div class="bg-grey-lighter p-3 italic">
        <p>No Pending Request</p>
      </div>
      <div class="text-center py-2">
        <button
          class="bg-brand rounded-lg p-3 text-white"
          @click.prevent="$refs.request_transfer.open()"
        >Request Transfer of Ownership</button>
      </div>
    </div>

    <div v-else>
      <div class="flex md:flex-row flex-col flex-no-wrap p-2 border-b">
        <div class="flex flex-row flex-grow items-center">
          <div class="flex flex-grow flex-col md:flex-row">
            <div class="flex-grow w-48 truncate py-1 font-medium">Email</div>
            <div class="flex-grow w-48 md:w-24 truncate py-1 font-medium">Created By</div>
            <div class="flex-grow w-48 md:w-24 truncate py-1 font-medium">Created At</div>
          </div>
          <div class="flex flex-grow flex-col md:flex-row">
            <div class="flex-grow py-1 w-48 md:w-24 font-medium">Consumed</div>
            <div class="flex-grow py-1 w-48 md:w-24 font-medium">Consumed At</div>
          </div>
        </div>
        <div class="flex flex-row flex-grow-0 w-20">&nbsp;</div>
      </div>

      <div class="flex md:flex-row flex-col flex-no-wrap px-2 py-4 border-t border-b">
        <div class="flex flex-row flex-grow items-center">
          <div class="flex flex-grow flex-col md:flex-row">
            <div class="flex-grow w-48 truncate py-1">{{pending_request.email}}</div>
            <div
              class="flex-grow w-48 md:w-24 truncate py-1"
            >{{getUser(pending_request.created_by_user_id)}}</div>
            <div
              class="flex-grow w-48 md:w-24 truncate py-1"
            >{{formatDate(pending_request.created_at)}}</div>
          </div>
          <div class="flex flex-grow flex-col md:flex-row">
            <div class="flex-grow w-48 md:w-24 truncate py-1">
              <p v-if="pending_request.is_consumed">
                <i class="fa fa-check text-brand mb-1"></i>
                <span class="font-medium">Yes</span>
              </p>
              <p v-else>
                <i class="fa fa-times text-brand mb-1"></i>
                <span class="font-medium">No</span>
              </p>
            </div>
            <div
              class="flex-grow w-48 md:w-24 truncate py-1"
            >{{formatDate(pending_request.consumed_at)}}</div>
          </div>
        </div>
        <div class="flex md:flex-col lg:flex-row flex-grow-0 justify-center">
          <button
            class="border border-red w-full sm:w-1/4 md:w-full rounded text-red p-2 text-xs flex-none hover:bg-red hover:text-white"
            @click.prevent="$refs.confirm_delete_request.open()"
            v-if="!pending_request.is_consumed"
          >
            <i class="fa fa-trash"></i> Delete
          </button>
        </div>
      </div>
    </div>

    <sweet-modal
      overlay-theme="dark"
      hide-close-button
      ref="request_transfer"
      enable-mobile-fullscreen
      class="no-padding-content"
    >
      <div class="bg-modal-gradient flex justify-center items-center text-white text-3xl p-6 px-2">
        <i class="fa fa-exchange-alt mr-4"></i> Request Transfer of Ownership
      </div>
      <div class="p-6">
        <form @submit.prevent="requestTransfer" data-vv-scope="request-transfer">
          <div class="w-full text-left my-4">
            <label class="font-medium">Email Address</label>
            <input
              type="text"
              class="w-full border py-2 px-3 mt-2 rounded"
              v-model="request_transfer.email"
              v-validate="'required|email'"
              name="email"
              tabindex="1"
              :class="{'border-red':errors.has('request-transfer.email')}"
            >
            <div
              v-show="errors.has('request-transfer.email')"
              class="text-red text-sm mt-2"
            >{{ errors.first('request-transfer.email') }}</div>
          </div>

          <div class="w-full flex justify-between mt-8 mb-2">
            <button
              class="border bg-brand px-4 py-3 text-white rounded font-medium hover:bg-brand-darker hover:border-brand-darker"
              type="submit"
            >
              <i class="fa fa-paper-plane"></i> Send Request
            </button>
            <button
              class="border border-red px-4 py-3 text-red rounded font-medium hover:text-white hover:bg-red-dark hover:border-red-dark"
              type="button"
              @click.prevent="$refs.request_transfer.close(); resetModalState()"
            >
              <i class="fa fa-times"></i> Close
            </button>
          </div>
        </form>
      </div>
    </sweet-modal>

    <sweet-modal icon="warning" overlay-theme="dark" ref="confirm_delete_request">
      <div class="flex flex-col">
        <span>Are you sure you want to delete this Transfer Request?</span>

        <div class="mt-6">
          <button
            class="border bg-brand p-4 w-32 text-white rounded font-medium"
            @click.prevent="deleteTransferRequest()"
          >Yes</button>
          <button
            class="border bg-grey-lighter p-4 w-32 text-black border-grey rounded font-medium"
            @click="$refs.confirm_delete_request.close()"
          >No</button>
        </div>
      </div>
    </sweet-modal>
  </div>
</template>

<script>
export default {
  props: ["users"],

  data() {
    return {
      pending_request: [],
      search_pending: true,

      request_transfer: {
        email: ""
      }
    };
  },

  mounted() {
    this.getPendingRequests();
  },

  methods: {
    getPendingRequests() {
      axios
        .get(`api/vaults/${this.$route.params.vault_id}/transfers/pending`)
        .then(({ data }) => {
          this.search_pending = false;
          this.pending_request = data;
          this.$ebus.$emit("refresh-transfer-requests");
        })
        .catch(error => {
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);

            let data = error.response.data;
            if (!data.success) {
              if (error.response.status == 403) {
                this.$noty.error(
                  "You are not authorized to access this page. Redirecting to Vaults list...",
                  {
                    timeout: 1500,
                    callbacks: {
                      afterClose: () => {
                        this.$router.push({
                          name: "vaults"
                        });
                      }
                    }
                  }
                );
              }
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log(error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log("Error", error.message);
          }
          console.log(error.config);
        });
    },

    requestTransfer() {
      this.$validator.validateAll().then(result => {
        if (result) {
          axios
            .post(`api/vaults/${this.$route.params.vault_id}/transfers`, {
              email: this.request_transfer.email
            })
            .then(({ data }) => {
              if (data.success) {
                this.$noty.success("Request has been sent");
                this.$refs.request_transfer.close();
                this.getPendingRequests();
              }
            });
        }
      });
    },

    deleteTransferRequest() {
      axios
        .delete(
          `api/vaults/${this.$route.params.vault_id}/transfers/${
            this.pending_request.id
          }`
        )
        .then(({ data }) => {
          if (data.success) {
            this.getPendingRequests();
            this.$refs.confirm_delete_request.close();
            this.$noty.success(data.message);
          }
        });
    },

    resetModalState() {},

    formatDate(date) {
      if (_.isNil(date)) {
        return "N/A";
      }
      let d = moment(date);
      return d.format("DD/MM/YYYY");
    },

    getUser(id) {
      let user = _.filter(this.users, { id: id });

      if (!_.isEmpty(user)) {
        return user[0].first_name + " " + user[0].last_name;
      }

      return "-";
    }
  }
};
</script>

<style>
</style>
